module.exports = __webpack_public_path__ + "static/media/peikko-success-story-banner.dffbc4b6.webp";